/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
export interface FilterChip {
  label: string;
  attribute: string;
  value?: any;
};

export type FilterChips = FilterChip[];

export enum BadgeType {
  iButton = 'iButton',
  Other = 'Other'
};

export enum InputTypes {
  PASSWORD = 'password',
  TEXT = 'text'
}

export enum AutoCompleteTypes {
  ON = 'on',
  OFF = 'off',
  NEW_PASSWORD = 'new-password'
}
